export function initSpecialProjectModule() {

    if (!document.querySelector('.magazine-specialpj-swiper')) {
        return;
    }

    // Magazine swiper per la pagina progetto speciale
    initializeSwiper('.magazine-specialpj-swiper', {
        slidesPerView: 1.25,
        spaceBetween: 40,
        loop: false,
        lazy: true,
        loadPrevNext: true,
        navigation: {
            nextEl: '.swiper-specialpj-nav-next',
            prevEl: '.swiper-specialpj-nav-prev',
            addIcons: false
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 2,
            },
            1400: {
                slidesPerView: 3,
            },
        },
        scrollbar: {
            el: '.specialpj-scrollbar-wrapper .swiper-scrollbar',
            draggable: true,
        },
    });
}